import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FaSpinner } from "react-icons/fa";
import toast from "react-hot-toast";
import * as B2BRegistrationService from "../../Services/B2BRegistration/B2BRegistrationService";

const AddDoctorModal = ({ showModal, setShowModal, orgId, orgName, locationId, locationName, onDoctorAdded }) => {
    const [loading, setLoading] = useState(false);
    const [submitError, setSubmitError] = useState("");

    const { register, handleSubmit, reset } = useForm({ defaultValues: { doctorName: "" } });

    useEffect(() => {
        if (!showModal) return;
        reset({ doctorName: "" });
        setSubmitError("");
    }, [showModal]);

    const resetModal = () => {
        reset({ doctorName: "" });
        setSubmitError("");
    };

    const handleClose = () => {
        resetModal();
        setShowModal(false);
    };

    const onSubmit = (data) => {
        setLoading(true);
        setSubmitError("");

        const payload = {
            Salutation: "Dr.",
            DoctorName: (data.doctorName || "").trim(),
            OrgId: orgId,
            OrgName: orgName,
            LocationId: locationId,
            LocationName: locationName
        };

        B2BRegistrationService.CreateDoctor(payload)
            .then(({ data: res }) => {
                if (res.IsSuccess) {
                    toast.success(res.ResponseMessage || "Doctor added successfully.");
                    resetModal();
                    setShowModal(false);
                    if (onDoctorAdded) {
                        onDoctorAdded({
                            Doctor_Name: payload.DoctorName,
                            RNI_Doctor_Id: res.Data?.RNI_Doctor_Id || null,
                            Doctor_Id: res.Data?.Doctor_Id || null,
                        });
                    }
                } else {
                    const msg = res.ResponseMessage || "Failed to add doctor.";
                    toast.error(msg);
                    setSubmitError(msg);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setLoading(false));
    };

    if (!showModal) return null;

    return (
        <div>
            <div className="modal-backdrop" style={{ zIndex: 10000 }}>
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ zIndex: 10001 }}>
                    <div className="modal-dialog modal-md custom-modal-com" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add Doctor</h5>
                                <button type="button" className="btn-close" onClick={handleClose}></button>
                            </div>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="modal-body">
                                    {submitError && (
                                        <div className="alert alert-danger py-2 px-3 mb-2" role="alert">
                                            {submitError}
                                        </div>
                                    )}

                                    <div className="mb-1">
                                        <label className="fw-bold mb-1">Doctor Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter doctor name"
                                            {...register("doctorName")}
                                        />
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        tabIndex={-1}
                                        onClick={handleClose}
                                    >
                                        Close
                                    </button>
                                    <button type="submit" className="btn custom-sumbitbtn" disabled={loading}>
                                        {loading ? <FaSpinner className="fa-spin mb-1" /> : "Save"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddDoctorModal;